import SEOSnippet from './SEOSnippet';

export default SEOSnippet;
